import React from "react";
import { Move } from "@/types";
import { formatStartWindow } from "@/lib/utils";
import { format, parseISO } from "date-fns";
import { CalendarIcon, ClockIcon, UserIcon, TruckIcon } from "lucide-react";

interface ScheduleProps {
  move: Move;
}

const Schedule: React.FC<ScheduleProps> = ({ move }) => {
  return (
    <>
      <table className="min-w-full">
        <thead>
          <tr>
            <th className="py-0.5 text-left text-sm">
              <div className="flex items-center gap-1">
                <CalendarIcon className="w-3 h-3" />
                <span className="text-xs text-stone-700 font-normal">Date</span>
              </div>
            </th>
            <th className="py-0.5 text-left text-sm">
              <div className="flex items-center gap-1">
                <ClockIcon className="w-3 h-3" />
                <span className="text-xs text-stone-700 font-normal">
                  Arrival Window
                </span>
              </div>
            </th>
            <th className="py-0.5 text-left text-sm">
              <div className="flex items-center gap-1">
                <UserIcon className="w-3 h-3" />
                <span className="text-xs text-stone-700 font-normal">
                  Movers
                </span>
              </div>
            </th>
            <th className="py-0.5 text-left text-sm">
              <div className="flex items-center gap-1">
                <TruckIcon className="w-3 h-3" />
                <span className="text-xs text-stone-700 font-normal">
                  Trucks
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody className="text-xs md:text-sm font-semibold">
          <tr>
            <td className="py-0.5">
              {move.service_date
                ? format(parseISO(move.service_date), "MM/dd/yyyy")
                : "-"}
            </td>
            <td className="py-0.5">
              {formatStartWindow(
                move.start_window_begin_hour,
                move.start_window_begin_minute,
                move.start_window_begin_meridiem
              )}{" "}
              to{" "}
              {formatStartWindow(
                move.start_window_end_hour,
                move.start_window_end_minute,
                move.start_window_end_meridiem
              )}
            </td>
            <td className="py-0.5">{move.num_of_movers || "-"}</td>
            <td className="py-0.5">{move.num_of_trucks || "-"}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default Schedule;
